export default __webpack_public_path__ + "static/media/sc21.e49b6cb6.mp4";